let module = angular.module('app.resources');

module.factory('AnalyticsResource', function AnalyticsResource($resource) {
  'ngInject';
  return $resource(
    `${API_ROOT}/account/viewer_analytics/:channel_id`,
    { channel_id: '@channel_id' },
    {}
  );
});

module.factory('AnalyticsExportResource', ($resource) => {
  'ngInject';
  return $resource(
    `${API_ROOT}/account/viewer_analytics/:channel_id/export`,
    { channel_id: '@channel_id' },
    {
      render: {
        method: 'GET',
        url: `${API_ROOT}/account/viewer_analytics/:channel_id/export`,
        responseType: 'arraybuffer',
        transformResponse: function (data, headers) {
          return {
            blob: new Blob([data], { type: headers('content-type') }),
            headers: headers(),
          };
        },
      },
    }
  );
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/analytics.js